import React, { Component } from 'react';
import { connect } from 'react-redux';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/AddCircle';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import { codeMngService } from '../../services';
import { alertActions } from '../../modules/alert';

class CodeAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            completed: 0,
            name: '',
            value: '',
            url: '',
            subCode: '',
            parentCode: props.parentCode,
            groupCode: props.groupCode,
            groupCodeName: props.groupCodeName,
            open: false
        }
    }

    enterPressed = (e) => {
        let code = e.keyCode || e.which;
        if(code === 13) { //13 is the enter keycode
            this.buttonAdd.click();
        }
    }

    handleFormSubmit = (e) => {
        e.preventDefault();
        this.addCode();

        this.setState({
            name: '',
            value: '',
            open: false
        });
    }

    handleValueChange = (e) => {
        let nextState = {};
        nextState[e.target.name] = e.target.value;
        this.setState(nextState);
    }

    addCode = () => {
        let formData = new FormData();
        formData.append('name', this.state.name);
        formData.append('value', this.state.value);
        formData.append('url', this.state.url);
        formData.append('subCode', this.state.subCode);
        if(this.state.parentCode)
            formData.append('parentCode', this.state.parentCode);
        formData.append('groupCode', this.state.groupCode);

        codeMngService.addCode(formData)
            .then((response) => {
                console.log(response.data);
                if(response.status===200){
                    this.props.successAlerts('코드를 등록하였습니다.');
                    this.props.stateRefresh();
                }
            })
            .catch( this.handleErrors );
    }

    handleErrors = (error) => {
        console.log(error.toString());
        if(error.response===undefined)
            this.props.errorAlerts("알 수 없는 오류가 발생하였습니다. 관리자에게 문의하시기 바랍니다.", "/home");
        else{
            if (error.response.status === 401)
                this.props.errorAlerts("권한이 없습니다.", "/login");
            else
                this.props.errorAlerts(error.response.data.message);
        }
    }

    handleClickOpen = () => {
        this.setState({
            name: '',
            value: '',
            url: '',
            subCode: '',
            parentCode: this.props.parentCode,
            groupCode: this.props.groupCode,
            groupCodeName: this.props.groupCodeName,
            open: true
        })
    }

    handleClose = () => {
        this.setState({
            open: false
        });
    }

    render() {
        let addButton;
        if(this.state.parentCode){
            addButton = 
                <IconButton aria-label="add" onClick={this.handleClickOpen}>
                    <AddIcon fontSize="small"/>
                </IconButton>;
        }else{
            addButton = 
                <button className="button primary-button" onClick={this.handleClickOpen}>
                    코드 추가
                </button>;
        }

        let groupCodeInputComp;
        if(this.props.parentCode && this.props.groupCode){
            groupCodeInputComp = <TextField labelid="group-select-label" type="text" value={this.props.groupCodeName} className="input-box"/>;
        }else{
            groupCodeInputComp = 
                <Select labelid="group-select-label" name="groupCode" onChange={this.handleValueChange} className="selector" value={this.state.groupCode}>
                    {this.props.groupCodes && this.props.groupCodes.map((groupCode) => <MenuItem key={groupCode.code} value={groupCode.code}>{groupCode.name}</MenuItem>)}
                </Select>;
        }

        return (
            <>
                {addButton}
                <Dialog open={this.state.open} onClose={this.handleClose}>
                    <DialogTitle>
                    {this.state.parentCode && 
                        '하위 '
                    } 
                    코드 추가
                    </DialogTitle>
                    <DialogContent>
                        <div className="form-group">
                            <InputLabel id="group-select-label">코드 그룹</InputLabel>
                            {groupCodeInputComp}
                        </div>
                        {this.props.parentCode &&
                            <div className="form-group">
                                <InputLabel id="parent-code-label">상위 코드</InputLabel>
                                <TextField labelid="parent-code-label" type="text" value={this.props.parentCode} className="input-box"/><br/>
                            </div>
                        }
                        <div className="form-group">
                            <InputLabel id="code-name-label">코드명</InputLabel>
                            <TextField labelid="code-name-label" type="text" name="name" value={this.state.name} onChange={this.handleValueChange} onKeyPress={this.enterPressed} className="input-box"/><br/>
                        </div>
                        <div className="form-group">
                            <InputLabel id="code-name-label">구분값</InputLabel>
                            <TextField labelid="code-name-label" type="text" name="value" value={this.state.value} onChange={this.handleValueChange} onKeyPress={this.enterPressed} className="input-box"/><br/>
                        </div>
                        {this.state.groupCode === 'LG' && 
                            <>
                                <div className="form-group">
                                    <InputLabel id="request-url-label">요청 URL</InputLabel>
                                    <TextField labelid="request-url-label" type="text" name="url" value={this.state.url} onChange={this.handleValueChange} onKeyPress={this.enterPressed} className="input-box"/><br/>
                                </div>
                                <div className="form-group">
                                    <InputLabel id="subcode-label">요청서비스 구분 코드</InputLabel>
                                    <TextField labelid="subcode-label" type="text" name="subCode" value={this.state.subCode} onChange={this.handleValueChange} onKeyPress={this.enterPressed} className="input-box"/><br/>
                                </div>
                            </>
                        }
                    </DialogContent>
                    <DialogActions>
                        <button className="button primary-button" onClick={this.handleFormSubmit} ref={button => this.buttonAdd = button}>추가</button>
                        <button className="button outline-button" onClick={this.handleClose}>닫기</button>
                    </DialogActions>
                </Dialog>
            </>
        )
    }
}

function mapState(state) {
    return state;
}

const actionCreators = {
    errorAlerts: alertActions.error,
    successAlerts: alertActions.success
};

export default connect(mapState, actionCreators)(CodeAdd);